import { ListOfCollapsableDataItem, useListContext } from 'framework/list';
import { DashboardZoneProps } from './dashboardZone.types';
import { DashboardItemData } from '../dashboard.types';
import { Box, Typography } from '@mui/material';
import { SmallLoader } from 'framework/ui/mui-builder';
import { DashboardZoneWrapper } from './dashboardZone.styles';

interface DashboardZoneHeaderProps {
  title: string;
  description?: string;
  descriptionIcon?: React.ReactNode;
  countElements: number;
  loading?: boolean;
}

const dashboardZoneDescriptionSx = {
  alignItems: 'center',
  display: 'flex',
  fontWeight: 600,
};

const DASHBOARD_ZONE_HEADER_CONTENT_OFFSET = 4.25;

const DashboardZoneHeader = ({
  title,
  description,
  descriptionIcon,
  countElements,
  loading,
}: DashboardZoneHeaderProps) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      p={1}
      pl={DASHBOARD_ZONE_HEADER_CONTENT_OFFSET}
    >
      <Typography display="flex" variant="subtitle2">
        {title}
        &nbsp;
        {loading ? <SmallLoader size="10px" /> : ` (${countElements})`}
      </Typography>

      {description && (
        <Typography variant="caption" sx={dashboardZoneDescriptionSx}>
          {descriptionIcon}
          {description}
        </Typography>
      )}
    </Box>
  );
};

const DashboardZone = ({ zone, items, renderItem, loading, customCount, sx, defaultExpanded }: DashboardZoneProps) => {
  const { data: { items: contextItems = [] } = {}, loading: contextLoading } = useListContext() || {};

  const dataItems = items || contextItems;
  const isLoading = loading !== undefined ? loading : contextLoading;

  return (
    <DashboardZoneWrapper accentColor={zone.accentColor}>
      <ListOfCollapsableDataItem<DashboardItemData>
        items={dataItems}
        sxWrapper={{
          pt: 1.25,
          ...(sx as any),
        }}
        filterFn={zone.filterFn}
        expanded={defaultExpanded}
        renderHeader={count => (
          <DashboardZoneHeader
            title={zone.title}
            description={zone.description}
            descriptionIcon={zone.descriptionIcon}
            countElements={customCount || count}
            loading={isLoading}
          />
        )}
        renderItem={(item, update) => renderItem(item, update)}
      />
    </DashboardZoneWrapper>
  );
};

export default DashboardZone;
